import React from 'react';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { ActionConfirmModal } from '@organisms/actions/ActionReason/ActionConfirmModal';
import { IRemoveLinkExecutorProps } from './IRemoveLinkExecutorProps';

export const RemoveLinkExecutorModal: React.FC<IRemoveLinkExecutorProps> = (props: IRemoveLinkExecutorProps) => (
    <ActionConfirmModal
        header={props.title}
        message={props.message}
        requireReason={props.requireReason}
        reasonLabel={props.reasonLabel}
        okButtonText={props.okButtonText}
        cancelButtonText={props.cancelButtonText}
        modalSize={props.modalSize}
        completeHandler={props.completeHandler}
        submit={(reason) =>
            new DocumentExecutionService(props.ownerDocId).removeLink(props.linkedDocId, props.actKey, reason)
        }
    />
);
